// extracted by mini-css-extract-plugin
export var callCard = "_mx-0";
export var callMessageButton = "_mx-1";
export var helpIcon = "_mx-3";
export var helpIconContainer = "_mx-4";
export var verticalDivider = "_mx-2";